export function showSelectDropdownAsyncListFooter({ Footer, options }) {
  return Footer && options?.length > 0
}

export function showSelectDropdownAsyncListHeader({ Header, options }) {
  return Header && options?.length > 0
}
